import { combineReducers } from 'redux';

import gridDisplay from './gridDisplay';
import productEditMode from './productEditMode';
import customerTooltip from './customerTooltip';

export default combineReducers({
  gridDisplay,
  productEditMode,
  customerTooltip,
});
